import { motion } from "framer-motion";

/**
 * Premium "Verified OpenAI Ads Partner" badge.
 * Metallic silver outer ring, dark core, OpenAI-green hexagon w/ verification checkmark,
 * curved text around the perimeter. Purely SVG — scales cleanly at any size.
 */
export default function OpenAIBadge({ size = 140, className = "" }) {
  return (
    <motion.div
      className={className}
      animate={{ y: [0, -6, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      data-testid="openai-badge"
    >
      <svg viewBox="0 0 200 200" width={size} height={size} className="drop-shadow-[0_0_40px_rgba(16,163,127,0.35)]">
        <defs>
          <linearGradient id="oa-silver" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0" stopColor="#f4f4f5" />
            <stop offset="0.45" stopColor="#a1a1aa" />
            <stop offset="1" stopColor="#3f3f46" />
          </linearGradient>
          <radialGradient id="oa-core" cx="0.5" cy="0.4" r="0.7">
            <stop offset="0" stopColor="#1f2937" />
            <stop offset="1" stopColor="#050505" />
          </radialGradient>
          <linearGradient id="oa-green" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0" stopColor="#34d399" />
            <stop offset="1" stopColor="#10a37f" />
          </linearGradient>
          <path id="oa-arc-top" d="M 30 100 A 70 70 0 0 1 170 100" fill="none" />
          <path id="oa-arc-bottom" d="M 30 100 A 70 70 0 1 0 170 100" fill="none" />
        </defs>

        {/* metallic outer ring */}
        <circle cx="100" cy="100" r="96" fill="url(#oa-silver)" />
        <circle cx="100" cy="100" r="96" fill="none" stroke="#111" strokeOpacity="0.35" strokeWidth="1" />

        {/* inner disc */}
        <circle cx="100" cy="100" r="82" fill="url(#oa-core)" />
        <circle cx="100" cy="100" r="82" fill="none" stroke="url(#oa-green)" strokeWidth="1.25" opacity="0.9" />
        <circle cx="100" cy="100" r="78" fill="none" stroke="#10a37f" strokeOpacity="0.35" strokeWidth="0.5" strokeDasharray="1 3" />

        {/* curved perimeter text */}
        <text fill="#e5e7eb" fontSize="10" letterSpacing="4" fontWeight="700" fontFamily="'Outfit', sans-serif">
          <textPath href="#oa-arc-top" startOffset="50%" textAnchor="middle">
            OPENAI · ADS · PARTNER
          </textPath>
        </text>
        <text fill="#a3a3a3" fontSize="8" letterSpacing="3" fontWeight="600" fontFamily="'Outfit', sans-serif">
          <textPath href="#oa-arc-bottom" startOffset="50%" textAnchor="middle">
            VERIFIED · EXCLUSIVE · INDIA
          </textPath>
        </text>

        {/* central hex + check */}
        <g transform="translate(100 105)">
          <polygon points="0,-32 28,-16 28,16 0,32 -28,16 -28,-16" fill="url(#oa-green)" opacity="0.18" />
          <polygon points="0,-32 28,-16 28,16 0,32 -28,16 -28,-16" fill="none" stroke="url(#oa-green)" strokeWidth="2" strokeLinejoin="round" />
          <path d="M -13 1 L -3 11 L 15 -10" fill="none" stroke="#34d399" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </motion.div>
  );
}
